module.exports = __webpack_public_path__ + "static/media/promo-radar.7a27fadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-radar.jpg
// module id = 316
// module chunks = 0